import { Time } from "./time";

export default Time;